import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import axios from 'axios';
import { ElMessage } from 'element-plus';
import _ from 'lodash';
import router from '@/router';
import { getLocale } from '@/utils/language';
import { logout } from './logout';
const env = process.env;
// const getToken = () => {
//   const href = window.location.href
//   return localStorage.getItem('cloud_authorization') || (href.includes('/gys-outer-home/') ? localStorage.getItem('gys_access_token') : localStorage.getItem('bgy_access_token'))
// }
// let token = getToken()
// create an axios instance
export const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // baseURL: '/api', // url = base url + request url
  timeout: 180000,
  headers: {
    'Cache-Control': 'no-cache'
  },
  baseURL: process.env.VUE_APP_API_PATH + '/integration-api' // url = base url + request url
});
//
// 取消请求，删除记录
const pending = []; // 声明一个数组用于存储每个请求的取消函数和axios标识
const CancelToken = axios.CancelToken;
const removePending = config => {
  for (const i in pending) {
    if (pending[i].url === config.url) {// 在当前请求在数组中存在时执行取消函数
      // pending[i].f() // 执行取消操作
      // pending.splice(Number(i), 1) // 根据具体情况决定是否在这里就把pending去掉
    }
  }
};
// 请求拦截器
service.interceptors.request.use(config => {
  const paramsStr = (config.url?.match(/\?(.*)/)?.[1] || '').replace(/\+|\[|\]/g, value => {
    return encodeURIComponent(value);
  });
  const params = Object.fromEntries(new URLSearchParams(paramsStr).entries());
  const authToken = localStorage.getItem('authToken');
  const routePath = router.currentRoute.value.path;
  if (paramsStr && params) config.params = params;
  config.url = config.url?.split('?')[0];
  if (!authToken || authToken === 'undefined') {
    const ur = config.url && config.url.startsWith('auth');
    const reg = config.url && config.url.startsWith('/register');
    const meta = config.url && config.url.startsWith('/data/hana/ZFO_PO_SUPPLIER_SRV/$metadata');
    if (!(ur || reg || meta)) {
      // return Promise.reject(config)
    }
    console.log(config.url);
  }
  if (!config.headers) {
    ;
    config.headers = {
      'Content-Type': 'application/json'
    };
  }
  if (authToken) {
    ;
    config.headers.authToken = `${authToken}`;
  }
  const ispSupplierEntity = JSON.parse(localStorage.getItem('gys_cur_supplier_info'));
  if (!_.isEmpty(ispSupplierEntity)) {
    ;
    config.headers.supplierId = ispSupplierEntity.supplierId;
    config.headers.supplierCode = ispSupplierEntity.supplierCode;
    config.headers.CsUsername = ispSupplierEntity.mobilePhone;
  }
  // else {
  //     ;(config.headers as any).supplierCode = '1000000001'
  // }
  const userInfo = JSON.parse(localStorage.getItem('cur_info'));
  if (!_.isEmpty(userInfo)) {
    ;
    config.headers.CsUsername = userInfo.userId;
  }
  // else {
  //     ;(config.headers as any).CsUsername = '31341069'
  // }
  ;
  config.headers['Accept-Language'] = getLocale();
  return config;
}, error => {
  return Promise.reject(error);
});
// 响应拦截器
service.interceptors.response.use(response => {
  /** 200状态处理 */
  // 请求成功直接返回响应体
  return response;
}, error => {
  console.log(error);
  /** 400 - 500 状态处理 */
  // 登录失败请求统一认证接口
  //   if ((error.response === undefined || error?.response?.status === 401)) {
  if (error.response === undefined) {
    ElMessage({
      message: '请求数据超时，请刷新页面重新尝试',
      grouping: true,
      type: 'error'
    });
  } else if (error?.response?.status === 401 || error?.response?.status === 403) {
    logout();
    ElMessage({
      message: '您的登录不存在或已过期，请重新登录',
      grouping: true,
      type: 'error'
    });
    return Promise.reject(error);
  } else if (error.response.status === 400) {
    if (error.response.request.responseType !== 'blob') ElMessage({
      type: 'error',
      message: error.response.data.error.message.value || error
    });
    return Promise.reject(error);
  } else if (error.response.status === 503) {
    ElMessage({
      type: 'error',
      message: '服务器开小差,请稍后尝试!'
    });
    return Promise.reject(error);
  }
  // 其他异常报错提示
  ElMessage({
    type: 'error',
    message: error.response.data.msg || error
  });
  return Promise.reject(error);
});
const getMethodType = function (option) {
  if (option.method && ['get', 'post', 'put', 'delete'].includes(option.method.toLowerCase())) {
    return option.method.toLowerCase();
  } else {
    throw new Error('method name is not be defined');
  }
};
const getPathParams = function (url) {
  if (!url) return [];
  const regex = /{([^}]+)}/g;
  const pathParams = [];
  let currentMatch;
  /* eslint-disable no-cond-assign */
  while (currentMatch = regex.exec(url)) {
    pathParams.push(currentMatch[1]);
  }
  return pathParams;
};
const request = async option => {
  const method = getMethodType(option);
  if (method === 'post' && option.data) {
    delete option.data.count;
  }
  const pathParams = getPathParams(option.url);
  let newUrl;
  if (option.pathParams) {
    newUrl = pathParams.reduce((url, pathParam) => {
      const paramVal = option.pathParams ? option.pathParams[pathParam] : '';
      if (paramVal) {
        return url ? url.replace(`{${pathParam}}`, paramVal) : url;
      } else {
        throw new Error(`${url} has invalid path params.`);
      }
    }, option.url);
  }
  Reflect.deleteProperty(option, 'pathParams');
  // 特殊处理模糊查询字符中带&的情况-start
  let url = option.url || '';
  const queryIndex = url.indexOf("?");
  if (queryIndex !== -1) {
    let params = url.slice(queryIndex + 1);
    params = params.replace(/eq\s'(.*?)&+(.*?)'/g, (...arg) => {
      return arg[0].replaceAll("&", encodeURIComponent("&"));
    });
    url = url.slice(0, queryIndex + 1) + params;
  }
  option.url = url;
  // 特殊处理模糊查询字符中带&的情况-end
  option = _.merge(option, {
    url: newUrl || option.url,
    method
  });
  const res = await service(option);
  if (res?.headers?.count && res?.data?.d) {
    res.data.d.count = Number(res.headers.count) || 0;
  }
  if (res?.headers?.countobj && res?.data?.d) {
    res.data.d.countobj = JSON.parse(res.headers.countobj);
  }
  if (res?.headers?.csuserauth) {
    localStorage.setItem('authToken', res.headers.csuserauth);
  }
  res.data.constructor.hasRequest = {
    url: option.url,
    method: method,
    pathParams: _.cloneDeep(pathParams)
  };
  return res.data;
};
export default request;